import { ROLE } from "~/types/__generated/gql/graphql";

export const LOCAL_STORAGE_KEYS = {
	TOKEN: "served:web:token",
	COMPANY_ID: "served:web:companyId",
	SETTINGS: "served:web:settings",
	LANGUAGE: "served:web:language",
	FILE_VIEW_PREFERENCE: "served:web:fileViewPreference",
	MULTI_SELECT_BUTTON: "served:web:multiSelectButton",
	SEARCH_BUTTON: "served:web:searchButton",
	FILE_SETTINGS: "served:web:fileSettings",
	DATA_DISPLAY: "served:web:dataDisplay",
};

export const ROLE_TITLE = {
	[ROLE.SUPER_ADMIN]: "Super Admin",
	[ROLE.ADMIN]: " Admin",
	[ROLE.STAFF]: "Staff",
};
